<template>
  <div class="imgBox min-w-1400">
    <div class="imgBox1 min-w-1400">
      <div class="img1 max-w-1400">
        <p class="imgItem1">นโยบายความเป็นส่วนตัว</p>
        <!-- <img :src="importedImg1" :alt="altText" class="imgItem1" /> -->
      </div>
    </div>
    <div class="imgBox2 min-w-1400">
      <div class="img2 max-w-1400">
        <!-- <h1>Cam kết bảo mật</h1> -->
        <!-- <div class="title-line"></div> -->
        <div class="textBox" style="white-space: pre-wrap">{{ text }}</div>
      </div>
    </div>
  </div>
</template>

<script>
// import importedImg1 from "@/page/passmorecompany/components/img/4_1.png";

export default {
  data() {
    return {
      altText: "protocolTitle",
      // importedImg1: importedImg1,
      text: `โดยการเยี่ยมชมแอปพลิเคชัน เรา บนมือถือและ/หรือเว็บ (“แอป”) (เรียกรวมกันว่า “แพลตฟอร์ม”) และใช้บริการที่เรามอบให้ (“บริการ”) คุณตกลงที่จะผูกพันตามข้อกำหนดและเงื่อนไขของนโยบายความเป็นส่วนตัวนี้ .
เพียงการเข้าถึงแพลตฟอร์มหรือส่วนหนึ่งส่วนใดของแพลตฟอร์ม คุณแสดงว่าคุณยินยอมต่อนโยบายความเป็นส่วนตัวนี้ และยินยอมให้มีการประมวลผลข้อมูลที่สามารถระบุตัวบุคคลของคุณได้ (ข้อมูลส่วนบุคคล ข้อมูลส่วนบุคคลที่ละเอียดอ่อน หรือข้อมูล) ให้กับบริษัทนโยบายความเป็นส่วนตัวนี้รวมอยู่ในและอยู่ภายใต้ข้อกำหนดการใช้งานของแพลตฟอร์ม
เพื่อวัตถุประสงค์ของนโยบายความเป็นส่วนตัวนี้ ผู้ใช้บริการอาจเป็นลูกค้า/ผู้สมัคร / ผู้ยืม/ ผู้บริโภค หรือบุคคลอื่นใดที่ใช้บริการหรือเข้าถึงแพลตฟอร์มของเรา (“ผู้ใช้” หรือ “คุณ” หรือ “ของคุณ”)
เพื่อทำความเข้าใจตัวตนของคุณให้ดีขึ้น และให้แน่ใจว่าผู้ใช้ของคุณตรงตามความต้องการด้านเครดิต ดังนั้น ก่อนที่คุณจะส่งใบสมัคร เราจำเป็นต้องได้รับอนุญาตจากคุณในการรวบรวมข้อมูล ติดต่อ และ SMS และอัปโหลด เรามุ่งมั่นที่จะใช้โปรโตคอลการถ่ายโอนข้อมูลที่ปลอดภัยเพื่อเข้ารหัสข้อมูลและรับรองความปลอดภัยของข้อมูล โปรดอย่าลังเลที่จะใช้ หากคุณไม่ตกลง เราจะไม่ดำเนินการนี้ และแอปพลิเคชันจะไม่สามารถให้บริการตามปกติแก่คุณได้ และออกจากแอปพลิเคชัน
การรวบรวมข้อมูลส่วนบุคคลของผู้ใช้
เมื่อคุณใช้แพลตฟอร์มของเรา เราจะรวบรวมและจัดเก็บข้อมูลของคุณที่คุณให้ไว้เป็นครั้งคราวโดยขออนุญาตจากคุณอย่างชัดเจนเพื่อรับข้อมูลที่จำเป็น เป้าหมายหลักของเราในการดำเนินการดังกล่าวคือการมอบประสบการณ์และบริการที่ปลอดภัย มีประสิทธิภาพ ราบรื่น และปรับแต่งตามความต้องการให้กับคุณ สิ่งนี้ช่วยให้เราสามารถให้บริการและคุณสมบัติที่ตรงกับความต้องการของคุณ และปรับแต่งแพลตฟอร์มของเราเพื่อให้ประสบการณ์ของคุณปลอดภัยและง่ายขึ้น และเพื่อปรับปรุงบริการที่เรามอบให้ ที่สำคัญกว่านั้นคือเราเก็บรวบรวมข้อมูลส่วนบุคคลจากคุณที่เราพิจารณาว่าจำเป็นเพื่อให้บรรลุวัตถุประสงค์ข้างต้น
โดยทั่วไป คุณสามารถเรียกดูเว็บไซต์หรือแอพโดยไม่ต้องแจ้งให้เราทราบว่าคุณเป็นใครหรือเปิดเผยข้อมูลใด ๆ เกี่ยวกับตัวคุณเอง อย่างไรก็ตาม ในการสร้างบัญชีบนแพลตฟอร์ม คุณต้องให้ข้อมูลพื้นฐานที่จำเป็นต่อการให้บริการที่ปรับแต่งโดยเฉพาะแก่เรา ข้อมูลที่เรารวบรวมจากคุณ รวมถึง:
1. ชื่อเต็มของคุณ;
2. อีเมล;
3. เพศ;
4. ภาพถ่าย;
5. ที่อยู่ทางไปรษณีย์;
6. รหัสไปรษณีย์
7.การติดต่อฉุกเฉิน
8. หมายเลขโทรศัพท์;
หากเป็นไปได้ เราจะระบุช่องบังคับและช่องที่ไม่บังคับ คุณมีตัวเลือกเสมอที่จะไม่ให้ข้อมูลใด ๆ โดยเลือกที่จะไม่ใช้บริการหรือคุณสมบัติเฉพาะบนแพลตฟอร์ม นอกจากนี้เรายังรวบรวมข้อมูลบัญชีผู้ใช้ซึ่งรวมถึงที่อยู่อีเมลและข้อมูลโปรไฟล์สาธารณะของผู้ใช้ เช่น ชื่อ รูปภาพ ASID ขึ้นอยู่กับโซเชียลมีเดียหรือแพลตฟอร์มเครือข่ายที่คุณชอบ Google หรือ Facebook เพื่อลงชื่อเข้าใช้แอพ ข้อมูลนี้จำเป็นเป็นส่วนหนึ่งของกระบวนการลงทะเบียนเพื่อเข้าถึงบริการของเรา และยังใช้เพื่อเติมฟิลด์ที่เกี่ยวข้องโดยอัตโนมัติในอินเทอร์เฟซของแอป เรายังรวบรวมข้อมูลที่สามารถระบุตัวตนอื่น ๆ เช่น ประวัติการทำธุรกรรมของคุณบนแพลตฟอร์ม เมื่อคุณตั้งค่าบัญชีฟรีกับเราตามรายละเอียดเพิ่มเติมด้านล่าง แม้ว่าคุณจะสามารถเรียกดูบางส่วนของแพลตฟอร์มของเราได้โดยไม่ต้องเป็นสมาชิกที่ลงทะเบียนดังที่กล่าวไว้ข้างต้น กิจกรรมบางอย่าง (เช่น การขอสินเชื่อจากผู้ให้กู้บุคคลที่สามบนแพลตฟอร์ม) จำเป็นต้องลงทะเบียนและคุณจะต้องให้รายละเอียดข้างต้น แพลตฟอร์มจะแสดงข้อมูลส่วนบุคคลที่รวบรวมจากคุณอย่างชัดเจน และคุณมีทางเลือกที่จะไม่ให้ข้อมูลส่วนบุคคลดังกล่าว อย่างไรก็ตาม สิ่งนี้จะจำกัดบริการที่มอบให้แก่คุณบนแพลตฟอร์ม
แอพของเรายังรวบรวมหมายเลขโทรศัพท์มือถือเพื่อตรวจสอบสถานะ SIM ที่ใช้งานบนอุปกรณ์ ระบุตัวตนของคุณโดยไม่ซ้ำกัน และป้องกันการฉ้อโกงและการเข้าถึงโดยไม่ได้รับอนุญาต
การรวบรวมตำแหน่งอุปกรณ์และข้อมูลอุปกรณ์
เรารวบรวมและตรวจสอบข้อมูลเกี่ยวกับตำแหน่งของอุปกรณ์ของคุณเพื่อให้บริการการสมัครสินเชื่อของคุณ เพื่อลดความเสี่ยงที่เกี่ยวข้องกับการสมัครสินเชื่อของคุณและเพื่อให้ข้อเสนอสินเชื่อที่ปรับแต่งล่วงหน้าได้รับการอนุมัติ นอกจากนี้ยังช่วยให้เราตรวจสอบที่อยู่ ตัดสินใจเกี่ยวกับความเสี่ยงด้านเครดิตได้ดีขึ้น และเร่งกระบวนการทราบลูกค้าของคุณ (KYC)
ข้อมูลที่แอปรวบรวมและการใช้งานนั้นขึ้นอยู่กับวิธีที่คุณจัดการการควบคุมความเป็นส่วนตัวบนอุปกรณ์ของคุณ เมื่อคุณติดตั้งแอป เราจะจัดเก็บข้อมูลที่เรารวบรวมไว้พร้อมกับตัวระบุเฉพาะที่เชื่อมโยงกับอุปกรณ์ที่คุณใช้ เรารวบรวมข้อมูลจากอุปกรณ์เมื่อคุณดาวน์โหลดและติดตั้งแอป และขอการอนุญาตจากคุณอย่างชัดเจนเพื่อรับข้อมูลที่จำเป็นจากอุปกรณ์
ข้อมูลที่เรารวบรวมจากอุปกรณ์ของคุณรวมถึงรุ่นฮาร์ดแวร์ รุ่นบิวด์ RAM ที่เก็บข้อมูล ตัวระบุอุปกรณ์ที่ไม่ซ้ำกัน เช่น IMEI, หมายเลขซีเรียล, SSAID; ข้อมูล SIM ที่รวมถึงผู้ให้บริการเครือข่าย สถานะการโรมมิ่ง รหัส MNC และ MCC ข้อมูล WIFI ที่มีที่อยู่ MAC และข้อมูลเครือข่ายมือถือเพื่อระบุอุปกรณ์โดยไม่ซ้ำกัน และรับรองว่าไม่มีอุปกรณ์ที่ไม่ได้รับอนุญาตทำหน้าที่ในนามของคุณเพื่อป้องกันการฉ้อโกง
เรารวบรวมข้อมูลเกี่ยวกับอุปกรณ์ของคุณเพื่อให้การอัปเดตอัตโนมัติและการรักษาความปลอดภัยเพิ่มเติมเพื่อไม่ให้บัญชีของคุณใช้ในอุปกรณ์ของผู้อื่น นอกจากนี้ ข้อมูลดังกล่าวยังให้ข้อเสนอแนะอันมีค่าแก่เราเกี่ยวกับตัวตนของคุณในฐานะผู้ถืออุปกรณ์ตลอดจนพฤติกรรมอุปกรณ์ของคุณ ซึ่งช่วยให้เราสามารถปรับปรุงบริการของเราและมอบประสบการณ์ผู้ใช้ที่ปรับแต่งเองได้ดียิ่งขึ้นให้กับคุณ
วัตถุประสงค์ของการรวบรวมข้อมูล
วัตถุประสงค์ในการรวบรวมข้อมูลที่คุณให้ไว้คือ:
1. สร้างตัวตนและตรวจสอบสิ่งเดียวกัน
2. เพื่อทำให้วิดีโอ KYC ของคุณสมบูรณ์;
3. ตรวจสอบ ปรับปรุง และบริหารจัดการแพลตฟอร์มของเรา
4. ให้บริการของเรา เช่น จัดทำโปรไฟล์เครดิตเพื่อวัตถุประสงค์ในการอำนวยความสะดวกในการกู้ยืมแก่คุณ
5. ออกแบบและนำเสนอผลิตภัณฑ์และบริการที่ปรับแต่งตามความต้องการที่นำเสนอโดยเรา/พันธมิตรทางการเงินบุคคลที่สามของเรา
6. วิเคราะห์วิธีการใช้แพลตฟอร์ม วินิจฉัยบริการหรือปัญหาทางเทคนิค และรักษาความปลอดภัย
7. ส่งการแจ้งเตือนการสื่อสาร ข้อมูลเกี่ยวกับผลิตภัณฑ์หรือบริการที่คุณร้องขอหรือประมวลผลข้อสงสัยและแอปพลิเคชันที่คุณได้ทำไว้บนแพลตฟอร์ม
8. จัดการความสัมพันธ์ของเรากับคุณและแจ้งให้คุณทราบเกี่ยวกับผลิตภัณฑ์หรือบริการอื่น ๆ ที่เราคิดว่าคุณอาจพบว่ามีประโยชน์บางอย่าง
9. ดำเนินการวิเคราะห์ข้อมูลเพื่อปรับปรุงบริการ / ผลิตภัณฑ์ที่มอบให้แก่ผู้ใช้
10. ใช้ข้อมูลผู้ใช้เพื่อให้สอดคล้องกับกฎหมายและข้อบังคับของประเทศ
11. ดำเนินการ KYC เพื่อตัวเราเอง / พันธมิตรการให้กู้ยืมบุคคลที่สามของเราตามข้อมูลที่แบ่งปันโดยผู้ใช้
12. ใช้ข้อมูลผู้ใช้ในรูปแบบอื่นที่กฎหมายอนุญาตเพื่อให้คุณสามารถรับบริการทางการเงินจากพันธมิตรผู้ให้กู้ยืมของเรา
13. เราจะใช้และเก็บรักษาข้อมูลตามระยะเวลาที่จำเป็นเพื่อให้บริการแก่คุณบนแพลตฟอร์ม เพื่อปฏิบัติตามภาระผูกพันทางกฎหมายของเรา เพื่อแก้ไขข้อพิพาท และบังคับใช้ข้อตกลงของเรา
การเปลี่ยนแปลงนโยบายความเป็นส่วนตัวนี้
เราขอสงวนสิทธิ์ในการเปลี่ยนแปลง แก้ไข เพิ่ม หรือลบบางส่วนของนโยบายความเป็นส่วนตัวนี้ได้ตลอดเวลาด้วยเหตุผลใดก็ตาม ในกรณีที่มีการเปลี่ยนแปลงใดๆ ในนโยบายความเป็นส่วนตัว เราจะอัปเดตสิ่งเดียวกันบนแพลตฟอร์ม เมื่อโพสต์แล้ว การเปลี่ยนแปลงเหล่านี้จะมีผลทันที เว้นแต่จะระบุไว้เป็นอย่างอื่น เราขอแนะนำให้คุณตรวจสอบหน้านี้เป็นระยะเพื่อดูข้อมูลล่าสุดเกี่ยวกับหลักปฏิบัติด้านความเป็นส่วนตัวของเรา การเข้าถึงหรือใช้บริการอย่างต่อเนื่องถือเป็นการยอมรับการเปลี่ยนแปลงและนโยบายความเป็นส่วนตัวที่แก้ไขเพิ่มเติม
การเข้าถึงข้อมูลของคุณ / ติดต่อเรา
เมื่อใดก็ได้ ผู้ใช้สามารถเลือกที่จะแก้ไข/แก้ไข หรือลบ/ถอนข้อมูลส่วนบุคคลใด ๆ ที่แบ่งปันเพื่อใช้แพลตฟอร์มได้ โปรดทราบว่าการลบหรือถอนข้อมูลอาจส่งผลต่อบริการที่เรามอบให้กับคุณ ในกรณีที่มีการแก้ไขข้อมูลส่วนบุคคล ผู้ใช้จะต้องจัดเตรียมเอกสารประกอบที่เกี่ยวข้องกับการเปลี่ยนแปลงข้อมูลส่วนบุคคลเพื่อวัตถุประสงค์ในการตรวจสอบโดยบริษัท
การควบคุมความเป็นส่วนตัวของคุณ
คุณมีทางเลือกบางอย่างเกี่ยวกับข้อมูลที่เรารวบรวมและวิธีการนำไปใช้:
1. การตั้งค่าระดับอุปกรณ์: อุปกรณ์ของคุณอาจมีการควบคุมที่กำหนดข้อมูลที่เรารวบรวม ตัวอย่างเช่น คุณสามารถแก้ไขสิทธิ์บนอุปกรณ์ Android ของคุณเพื่อเข้าถึงสิทธิ์เข้าถึงกล้องหรือเสียงได้
2. ลบบัญชีแอปทั้งหมดของคุณ
3. คุณยังสามารถขอลบเนื้อหาออกจากเซิร์ฟเวอร์ของเราตามกฎหมายที่บังคับใช้หรือโดยการเขียนถึงเจ้าหน้าที่รับเรื่องร้องเรียนของเรา
ข้อควรระวังด้านความปลอดภัย
แพลตฟอร์มตั้งใจที่จะปกป้องข้อมูลของคุณและรักษาความถูกต้องตามที่คุณยืนยัน เราใช้มาตรการป้องกันทางกายภาพ การบริหาร และทางเทคนิคที่เหมาะสมเพื่อช่วยเราปกป้องข้อมูลของคุณจากการเข้าถึง การใช้ และการเปิดเผยโดยไม่ได้รับอนุญาต ตัวอย่างเช่น เราเข้ารหัสข้อมูลทั้งหมดเมื่อเราส่งผ่านอินเทอร์เน็ต นอกจากนี้เรายังกำหนดให้ผู้ให้บริการบุคคลที่สามที่ลงทะเบียนของเราปกป้องข้อมูลดังกล่าวจากการเข้าถึง การใช้ และการเปิดเผยโดยไม่ได้รับอนุญาต
แพลตฟอร์มของเรามีมาตรการรักษาความปลอดภัยที่เข้มงวดเพื่อป้องกันการสูญหาย การใช้ในทางที่ผิด และการเปลี่ยนแปลงข้อมูลภายใต้การควบคุม เราพยายามที่จะปกป้องและรับรองความปลอดภัยของข้อมูลที่คุณให้ไว้ เราใช้การเข้ารหัสแบบ Secure Sockets Layers (SSL) สำหรับการส่งข้อมูล ซึ่งปัจจุบันเป็นระดับการเข้ารหัสที่จำเป็นในศรีลังกาตามกฎหมายที่บังคับใช้
ความยินยอมของคุณ
โดยการใช้แพลตฟอร์มและการให้ข้อมูลของคุณ คุณยินยอมให้มีการรวบรวม แบ่งปัน เปิดเผย และการใช้ข้อมูลที่คุณเปิดเผยบนแพลตฟอร์มตามนโยบายความเป็นส่วนตัวนี้
หากเราตัดสินใจที่จะเปลี่ยนแปลงนโยบายความเป็นส่วนตัวของเรา เราจะโพสต์การเปลี่ยนแปลงเหล่านั้นบนหน้านี้เพื่อแจ้งให้คุณทราบถึงข้อมูลที่เรารวบรวม วิธีที่เราใช้ข้อมูล และภายใต้สถานการณ์ที่เราแบ่งปันและเปิดเผยข้อมูลดังกล่าว`,
    };
  },
  created() {
    this.gotoTop();
  },
  methods: {
    gotoTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
  },
};

</script>

<style scoped>
.imgBox {
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
}

.imgBox1 {
  display: flex;
  justify-content: center;
  width: 100%;
  min-width: 1400px;
  background-color: "";
}

.imgBox2 {
  display: flex;
  justify-content: center;
  max-width: 1400px;
  padding-top: 40px;
  padding-bottom: 20px;
  height: 3700px;
  background-color: #ffffff;
  border-radius: 32px;
  margin: -140px auto 150px;
}

.imgBox3 {
  display: flex;
  justify-content: center;
  width: 100%;
  min-width: 1400px;
  background-color: "";
}

img {
  display: block;
}

.img1 {
  overflow: hidden;
  width: 100%;
}

.img2,
.img4 {
  overflow: hidden;
}

.img3 {
  width: 100%;
  overflow: hidden;
  margin-left: 0;
  margin-right: 0;
}

.imgItem1 {
  width: 100%;
  margin-top: 0;
  margin-bottom: 0;
}

.imgItem2 {
  max-width: 100%;
}

.imgItem3 {
  width: 100%;
  overflow: hidden;
  margin-left: 0;
  margin-right: 0;
}

h1 {
  margin-top: 50px;
  margin-left: 490px;
  color: #3f4842;
  font-size: 40px;
  /* border-bottom: 5px solid #04358A; */
  display: inline-block;
}

.textBox {
  margin-top: 50px;
  margin-left: 100px;
  margin-right: 100px;
  font-size: 18px;
  color: #333333;
}

.imgBox2 {
  transform: scale(90%);
  /* transform: scale(80%); */
  margin: -150px auto 100px;
  height: 2500px;
  box-shadow: 0 1px 4.8px 0px rgba(0, 0, 0, 0.25);
  /* border: 2px solid #4D64E4; */
  border-radius: 36px;
  /* border-top: 1px solid #457b9d;
  border-bottom: 1px solid #457b9d; */
}
.textBox {
  margin-top: 20px;
  margin-left: 50px;
  margin-right: 50px;
}
/* .imgBox2{
  border-radius: 0;
  border-top: 3px solid #7c2af8;
  border-left: 2px solid #e9e9e9;
  border-right: 2px solid #e9e9e9;
  border-bottom: 3px solid #c1c1c1;
} */
.title-line {
  width: 430px;
  /* background: url(./components/img/Group1.png); */
  /* background-repeat: no-repeat; */
  /* background-position: -150px 10px; */
  /* height: 50px; */
  /* border: 1px solid red; */
  border: 2px solid #4d64e4;
  margin: 0 500px;
}

.img1 {
  /* background: radial-gradient(57.03% 57.03% at 50% 50%, #3C51A0 0%, #223479 100%); */
  height: 291px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.imgItem1 {
  color: #333333;
  font-family: "Thonburi";
  font-weight: 700;
  font-size: 34px;
  text-align: center;
}
</style>
